<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
               <!-- Summary info -->
                <v-flex lg6 pa-0 pl-3 pt-3>
                    <v-btn
                        :color="order.Status | order_status_color(1)"
                        width="160px"
                        height="36px"
                        small
                        dark
                        depressed
                        outlined
                    >{{ order.Status | order_status(1)}}</v-btn>
                </v-flex>
                <!-- Action buttons -->
                <v-flex lg6 pa-0 pr-3 pt-6>
                    <v-layout row wrap justify-end class="pr-3">
                        <v-btn @click="MarkDoneOrder" v-if="orderPaymentReady">
                            Chờ thanh toán
                        </v-btn>
                        <v-btn class="ml-2" v-if="!canReorder && adminRole" @click="backAmountVND = order.Payment; dialogCancelOrder = true">
                            Hủy đơn
                        </v-btn>
                        <v-btn @click="ReOrder" v-if="canReorder" class="ml-2">
                            Lên đơn
                        </v-btn>
                        <v-btn @click="duplicateOrder" class="ml-2">
                            Đơn bổ sung
                        </v-btn>
                        <order-flag-menu class="ml-2" :orderID="orderId" :orderType="2"></order-flag-menu>
                    </v-layout>
                </v-flex>
                <!-- Ghi chu don hang -->
                <v-flex sm12 md12 lg12 v-if="order.Note && order.Note != ''">
                    <v-widget title="Ghi chú">
                        <div slot="widget-header-action">
                            <v-icon color="yellow darken-3">note</v-icon>
                        </div>
                        <div slot="widget-content">
                            <v-card-text class="pa-0">{{order.Note}}</v-card-text>
                        </div>
                    </v-widget>
                </v-flex>
                <v-flex lg6>
                    <v-widget :title="'#'+orderId">
                        <div slot="widget-header-action">
                            <h4 class="pl-2 pr-3 font-weight-bold">{{order.CreatedDate | display_date('DD-MM-YYYY HH:mm:ss') | capitalize}}</h4>
                        </div>
                    <div slot="widget-content" class="customer-info-box">
                            <v-card-text>
                                <v-layout row wrap pt-0>
                                    <v-flex lg4 sm4>
                                        <v-card-title class="pa-0">Người đặt hàng</v-card-title>
                                    </v-flex>
                                    <v-flex lg8 sm8 pa-0>
                                        <v-row no-gutters>
                                            <div class="mt-4 account-toggle font-weight-bold text-red">{{customer.ID}}-{{customer.Username}} <span class="icon" :class="{'open':showCustomerDetail}"><i aria-hidden="true" class="v-icon notranslate mdi mdi-chevron-down theme--light"></i></span></div>
                                            <v-chip color="red darken-2" text-color="white" small class="mr-1 mb-1" v-if="diffUID">
                                                Tồn tại mã vận đơn thuộc khách hàng khác
                                            </v-chip>
                                        </v-row>
                                        <v-row no-gutters v-if="adminRole || saleRole">
                                            <v-chip color="blue darken-2" text-color="white" small class="mr-1 mb-1">
                                                <a :href="customer.ContactID ? '/lead-manager/lien-he/'+customer.ContactID : '#'" target="_blank" style="color: #ffffff; text-decoration: none;">Chi tiết liên hệ</a>
                                            </v-chip>
                                            <v-chip color="green darken-2" text-color="white" small class="mr-1 mb-1">
                                                <a :href="'/khach-hang/quan-ly-khach-hang/'+customer.ID" target="_blank" style="color: #ffffff; text-decoration: none;">Chi tiết user</a>
                                            </v-chip>
                                        </v-row>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap pt-0>
                                    <v-flex lg12 sm12 style="height: 111px" v-if="(!customerView || !showCustomerDetail)">
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap pt-0>
                                    <v-flex lg4 sm4>
                                        <v-card-title class="pa-0">Kho gửi</v-card-title>
                                    </v-flex>
                                    <v-flex lg8 sm8 pa-0>
                                        <v-select :disabled="orderReadonly || (!adminRole && (order.Status == statusEnum.da_nhap_kho_nhan || order.Status == statusEnum.da_thanh_toan)) || orderEditable.CheckPayment == 1" class="pa-0" :items="order.PriceType != 2 ? chinaStore_list : r_chinaStore_list" v-model="orderEditable.ChinaStoreID" item-text="Name" item-value="ID" item-disabled="IsHidden"></v-select>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap pt-0>
                                    <v-flex lg4 sm4>
                                        <v-card-title class="pa-0">Kho nhận</v-card-title>
                                    </v-flex>
                                    <v-flex lg8 sm8 pa-0>
                                        <v-select :disabled="orderReadonly || (!adminRole && (order.Status == statusEnum.da_nhap_kho_nhan || order.Status == statusEnum.da_thanh_toan)) || orderEditable.CheckPayment == 1" class="pa-0" :items="order.PriceType != 2 ? warehouse_list : r_warehouse_list" v-model="orderEditable.ReceivePlaceID" item-text="Name" item-value="ID" item-disabled="IsHidden"></v-select>
                                        <span class="red--text pa-0 ma-0" v-if="order.RealStoreName">Đơn hàng về sai kho nhận</span>
                                        <span class="red--text pa-0 ma-0" v-else-if="order.WrongStore > 1">Đơn hàng có kiện không cùng kho nhận</span>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap pt-0>
                                    <v-flex lg4 md4>
                                        <v-card-title class="pa-0 font-weight-bold text-red">Địa chỉ nhận</v-card-title>
                                    </v-flex>
                                    <v-flex lg8 sm8 pa-0>
                                        <v-textarea label="Địa chỉ nhận" v-model="orderEditable.ReceiveAddress" rows="2" :disabled="!(order.Status == statusEnum.huy_don_hang || order.Status == statusEnum.da_nhap_kho_gui || order.Status == statusEnum.dang_den_kho_gui || adminRole)"></v-textarea>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap pt-0>
                                    <v-flex lg4 md4>
                                        <v-card-title class="pa-0 font-weight-bold">Loại hàng</v-card-title>
                                    </v-flex>
                                    <v-flex lg8 sm8 pa-0>
                                        <v-select class="pa-0 font-weight-bold" :items="product_types" v-model="orderEditable.ProductType" item-text="name" item-value="value" :disabled="!(adminRole || paymentRole) || orderEditable.CheckPayment == 1"></v-select>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </div>
                    </v-widget>
                </v-flex>
                <!-- Danh gia don hang -->
                <v-flex v-if="(orderRole & 8)" lg6>
                    <v-widget title="Tin nhắn">
                        <div slot="widget-content">
                            <message-box :orderId="orderId" :orderType="2"></message-box>
                        </div>
                    </v-widget>
                </v-flex>
                <!-- Ma van don & don hang CN -->
                <v-flex lg12>
                    <v-widget title="Mã vận đơn">
                        <div slot="widget-header-action">
                            <div v-if="missingPackage" class="missing-package-alert">
                                Thiếu kiện
                            </div>
                        </div>
                        <div slot="widget-content">
                            <div class="warning-internal" v-if="diffChinaStoreID">
                                <i class="fa fa-exclamation-circle" aria-hidden="true"></i> Tồn tại mã vận đơn có kho gửi khác với kho gửi của đơn hàng
                            </div>
                            <order-transaction :currentOrder="order" :orderType="1" :priceType="order.PriceType" :disabled="storeVNRole" :locked="lockedOrder || orderEditable.CheckPayment == 1"></order-transaction>
                        </div>
                    </v-widget>
                </v-flex>
                <!-- Chi phi don hang -->
                <v-flex md12 lg12 sm12 xs12>
                    <v-widget title="Chi phí đơn hàng">
                        <div slot="widget-header-action" class="pt-6">
                            <v-checkbox :disabled="!adminRole && !paymentRole" class="pl-3" v-model="orderEditable.CheckPayment" label="Đã kiểm tra tài chính"></v-checkbox>
                        </div>
                        <div slot="widget-content">
                            <div class="warning-internal" v-if="order.WarningFeeWeightCommission">
                                <i class="fa fa-exclamation-circle" aria-hidden="true"></i> Hãy xem xét lại giá bán, hệ thống phát hiện mức giá bán đáng ngờ so với giá niêm yết
                            </div>
                            <v-radio-group
                                v-model="extraOptions"
                                row
                                class="pa-0 pt-2"
                                :disabled="!(order.Status == statusEnum.dang_den_kho_gui || paymentRole || adminRole) || lockedOrder || orderEditable.CheckPayment == 1"
                                >
                                <v-radio
                                    label="Theo cấp độ an toàn của hàng hóa."
                                    value="safe-level"
                                ></v-radio>
                                <v-radio
                                    label="Tùy chỉnh Bảo hiểm & Gia cố an toàn hàng"
                                    value="optional"
                                ></v-radio>
                            </v-radio-group>
                            <v-layout row wrap>
                                <v-flex lg11 sm12 pa-0 ma-0>
                                    <v-layout row wrap v-if="extraOptions == 'optional'">
                                        <v-flex lg2 sm2 pa-0 pt-6 pl-4>
                                            <v-checkbox label="Dịch vụ đóng gỗ" v-model="orderEditable.IsFragileGoods" :disabled="!(order.Status == statusEnum.dang_den_kho_gui || paymentRole || adminRole) || lockedOrder || orderEditable.CheckPayment == 1"></v-checkbox>
                                        </v-flex>
                                        <v-flex lg2 sm2 pa-0 pt-6 pl-4>
                                            <v-checkbox label="Dịch vụ bọt khí" v-model="orderEditable.IsFoam" :disabled="!(order.Status == statusEnum.dang_den_kho_gui || paymentRole || adminRole) || lockedOrder || orderEditable.CheckPayment == 1"></v-checkbox>
                                        </v-flex>
                                        <v-flex lg2 sm2 pa-0 pt-6>
                                            <v-checkbox label="Dịch vụ kiểm hàng (gói A)" v-model="isCheckPackageA" :disabled="!(order.Status == statusEnum.dang_den_kho_gui || paymentRole || adminRole) || lockedOrder || orderEditable.CheckPayment == 1"></v-checkbox>
                                        </v-flex>
                                        <v-flex lg2 sm2 pa-0 pt-6>
                                            <v-checkbox label="Dịch vụ kiểm hàng (gói B)" v-model="isCheckPackageB" :disabled="!(order.Status == statusEnum.dang_den_kho_gui || paymentRole || adminRole) || lockedOrder || orderEditable.CheckPayment == 1"></v-checkbox>
                                        </v-flex>
                                        <v-flex lg4 sm4 pb-0>
                                            <v-select label="Bảo hiểm hàng" v-model="orderEditable.GuaranteeType" :items="guarantees" item-text="PackageName" item-value="ID" :disabled="!(adminRole || paymentRole || (purchaseRole && csRole && (order.Status == statusEnum.dang_den_kho_gui))) || orderEditable.CheckPayment == 1"></v-select>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap v-else>
                                        <v-flex lg3 sm3 pa-0 pt-6 pl-6>
                                            <v-select label="Cấp độ an toàn" class="pa-0 font-weight-bold" clearable :items="safeLevels" v-model="orderEditable.SafeLevelID" item-text="Name" item-value="ID" item-disabled="HideOnAdmin" :disabled="!(adminRole || paymentRole) || orderEditable.CheckPayment == 1"></v-select>
                                        </v-flex>
                                    </v-layout>
                                    <v-divider></v-divider>
                                    <v-layout row wrap>
                                        <v-flex lg3 sm3 pb-0>
                                            <v-card-title>Tỷ giá</v-card-title>
                                        </v-flex>
                                        <v-flex lg9 sm9 pb-0>
                                            <v-layout row wrap>
                                                <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                    <h-currency-input v-model="orderEditable.CurentCNYVN" label="₫" :decimal="0" :disabled="!((order.Status == statusEnum.dang_den_kho_gui && !storeVNRole) || adminRole) || lockedOrder || orderEditable.CheckPayment == 1"></h-currency-input>
                                                </v-flex>
                                                <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                        <v-flex lg3 sm3 pb-0>
                                            <v-card-title>Hoa hồng vận chuyển</v-card-title>
                                        </v-flex>
                                        <v-flex lg9 sm9 pb-0>
                                            <v-layout row wrap>
                                                <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                    <h-currency-input v-bind:class="{'warning-amount': !orderEditable.FeeWeightCommission && order.WarningFeeWeightCommission}" v-model="orderEditable.FeeWeightCommission" :decimal="1" label="Hoa hồng vận chuyển (%)" :disabled="orderEditable.CheckPayment == 1 || !(adminRole || paymentRole)"></h-currency-input>
                                                </v-flex>
                                                <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                    <v-checkbox class="pl-3" v-model="orderEditable.FixFeeWeightCommission" label="Fix hoa hồng" v-if="adminRole || paymentRole" :disabled="orderEditable.CheckPayment == 1"></v-checkbox>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap pt-3>
                                        <v-flex lg3 sm3 pt-0>
                                            <v-card-title>Phí ship nội địa</v-card-title>
                                        </v-flex>
                                        <v-flex lg9 sm9 pt-0>
                                            <v-layout row wrap>
                                                <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                    <v-layout row wrap>
                                                        <v-flex lg6 sm6 pa-0 pl-3 pr-2><h-currency-input v-model="orderEditable.FeeShipCN" label="Phí ship nội địa (¥)" :decimal="1" :disabled="lockedOrder || orderEditable.CheckPayment == 1"></h-currency-input></v-flex>
                                                        <v-flex lg6 sm6 pa-0 pl-3 pr-2><h-currency-input v-model="order.FeeShipVND" :decimal="0" label="₫" disabled></h-currency-input></v-flex>
                                                    </v-layout>
                                                </v-flex>
                                                <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                    <v-layout row wrap>
                                                        <v-flex lg6 sm6 pa-0 pl-3 pr-2><h-currency-input v-model="orderEditable.RealFeeShipCN" label="Phí ship nội địa thực chi (¥)" :decimal="1" :disabled="lockedOrder || orderEditable.CheckPayment == 1"></h-currency-input></v-flex>
                                                        <v-flex lg6 sm6 pa-0 pl-3 pr-2><h-currency-input v-model="order.RealFeeShipCNVND" :decimal="0" label="₫" disabled></h-currency-input></v-flex>
                                                    </v-layout>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout class="blue--text" row wrap v-if="orderEditable.SafeLevelID">
                                        <v-flex lg3 sm3 pt-0>
                                            <v-card-text>Phí cấp độ an toàn</v-card-text>
                                        </v-flex>
                                        <v-flex lg9 sm9 pt-0>
                                            <v-layout row wrap>
                                                <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                    <h-currency-input v-model="order.SafeLevelWeightAmount" label="đ" :decimal="0" disabled></h-currency-input>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                        <v-flex lg3 sm3 pt-0>
                                            <v-card-title>Kiểu tính phí vận chuyển</v-card-title>
                                        </v-flex>
                                        <v-flex lg9 sm9 pt-0>
                                            <v-layout row wrap>
                                                <v-flex lg6 sm6 pb-0>
                                                    <v-select label="Kiểu tính phí" v-model="orderEditable.FeeShipType" :items="feeshiptypes" item-text="name" item-value="value" :disabled="!(adminRole|| paymentRole) || lockedOrder || orderEditable.CheckPayment == 1"></v-select>
                                                </v-flex>
                                                <v-flex lg6 sm6 pa-0 pl-2 pr-2 pt-4>
                                                    <v-card-title>Tổng cân: {{(totalWeight ? totalWeight : totalWeightByBigpackage) | currency('', 2)}}kg, Tổng khối: {{(totalVolume ? totalVolume : totalVolumeByBigpackage) | currency('', 2)}}m3</v-card-title>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                        <v-flex lg3 sm3 pt-0>
                                            <v-card-title>Phí vận chuyển (CK: {{orderEditable.FeeWeightDiscount | currency}}%)</v-card-title>
                                        </v-flex>
                                        <v-flex lg3 sm3 pa-0 pl-2 pr-2>
                                            <h-currency-input v-model="order.OrderWeight" decimal="2" :label="order.FeeShipType == 0 ? 'Tổng cân nặng (kg)' : order.FeeShipType == 1 ? 'Tổng khối (m3)' : 'Tổng cân nặng kg(quy đổi)'" disabled></h-currency-input>
                                        </v-flex>
                                        <v-flex lg3 sm3 pa-0 pl-2 pr-2>
                                            <h-currency-input v-model="order.FeeWeight" :decimal="0" label="Phí vận chuyển (₫)" disabled></h-currency-input>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout class="red--text" row wrap>
                                        <v-flex lg3 sm3 pt-0>
                                            <v-card-title>Giá niêm yết</v-card-title>
                                        </v-flex>
                                        <v-flex lg3 sm3 pt-0>
                                           <h-currency-input v-model="orderEditable.ListedWeightPrice" :label="order.PriceType == 2 ? 'Đơn giá cân/khối đầu (₫)' : 'Đơn giá (₫)'" :decimal="0" :disabled="!(adminRole || paymentRole) || lockedOrder || orderEditable.CheckPayment == 1"></h-currency-input>
                                        </v-flex>
                                        <v-flex lg2 sm2 pt-0>
                                           <v-checkbox class="pt-6" v-model="orderEditable.FixListedWeightPrice" label="Fix đơn giá" v-if="adminRole || paymentRole" :disabled="lockedOrder || orderEditable.CheckPayment == 1"></v-checkbox>
                                        </v-flex>
                                        <v-flex lg2 sm2 pt-0 v-if="order.PriceType == 2">
                                           <h-currency-input v-model="orderEditable.ListedWeightPriceSnd" label="Giá cân/khối tiếp theo (₫)" :decimal="0" :disabled="!(adminRole || paymentRole) || lockedOrder || orderEditable.CheckPayment == 1"></h-currency-input>
                                        </v-flex>
                                        <v-flex lg2 sm2 pt-0 v-if="order.PriceType == 2">
                                            <v-checkbox class="pt-6" v-model="orderEditable.FixListedWeightPriceSnd" label="Fix đơn giá" v-if="adminRole || paymentRole" :disabled="lockedOrder || orderEditable.CheckPayment == 1"></v-checkbox>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout class="blue--text" row wrap>
                                        <v-flex lg3 sm3 pt-0> <v-card-title>Giá bán</v-card-title></v-flex>
                                        <v-flex lg3 sm3 pt-0>
                                           <h-currency-input v-model="orderEditable.WeightPrice" :label="order.PriceType == 2 ? 'Đơn giá cân/khối đầu (₫)' : 'Đơn giá (₫)'" :decimal="0" :disabled="!(adminRole || paymentRole || (purchaseRole && csRole)) || lockedOrder || orderEditable.CheckPayment == 1"></h-currency-input>
                                           <span class="red--text" v-if="warningFeeWeight">Hãy xem xét lại giá bán có cộng các phí khác vào không?</span>
                                        </v-flex>
                                        <v-flex lg2 sm2 pt-0>
                                            <v-checkbox class="pt-6" v-model="orderEditable.IsUpdateFeeShip" label="Fix đơn giá" v-if="adminRole || paymentRole || (purchaseRole && csRole)" :disabled="lockedOrder || orderEditable.CheckPayment == 1"></v-checkbox>
                                        </v-flex>
                                        <v-flex lg2 sm2 pt-0 v-if="order.PriceType == 2">
                                           <h-currency-input v-model="orderEditable.WeightPriceSnd" label="Giá cân/khối tiếp theo (₫)" :decimal="0" :disabled="!(adminRole || paymentRole || (purchaseRole && csRole)) || lockedOrder || orderEditable.CheckPayment == 1"></h-currency-input>
                                        </v-flex>
                                        <v-flex lg2 sm2 pt-0 v-if="order.PriceType == 2">
                                            <v-checkbox class="pt-6" v-model="orderEditable.IsUpdateFeeShipSnd" label="Fix đơn giá" v-if="adminRole || paymentRole || (purchaseRole && csRole)" :disabled="lockedOrder || orderEditable.CheckPayment == 1"></v-checkbox>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                        <v-flex lg3 sm3 pt-0>
                                            <v-card-text>Phí ship tận nhà</v-card-text>
                                        </v-flex>
                                        <v-flex lg9 sm9 pt-0>
                                            <v-layout row wrap>
                                                <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                    <h-currency-input v-model="orderEditable.FeeShipVN" :decimal="0" label="Phí báo khách (₫)" :disabled="(existExported && !adminRole) || orderEditable.CheckPayment == 1"></h-currency-input>
                                                </v-flex>
                                                <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                    <h-currency-input v-model="orderEditable.RealFeeShipVN" :decimal="0" label="Phí thực chi (₫)" :disabled="(existExported && !adminRole) || orderEditable.CheckPayment == 1"></h-currency-input>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout class="blue--text" row wrap>
                                        <v-flex lg3 sm3 pt-0>
                                            <v-card-text>Chi phí phát sinh</v-card-text>
                                        </v-flex>
                                        <v-flex lg9 sm9 pt-0>
                                            <v-layout row wrap>
                                                <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                    <h-currency-input v-model="order.TotalOtherFee" label="₫" :decimal="0" disabled></h-currency-input>
                                                </v-flex>
                                                <v-flex lg6 sm6 pa-0 pl-2 pr-2 pt-2>
                                                    <v-btn color="blue darken-1" outlined @click="openOtherFeePopup">Chi tiết</v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout class="font-weight-bold" row wrap>
                                        <v-flex lg3 sm3>
                                            <v-card-text>Phí khác</v-card-text>
                                        </v-flex>
                                        <v-flex lg9 sm9>
                                            <v-layout row wrap>
                                                <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                    <h-currency-input v-model="orderEditable.FeeOther" :decimal="0" label="Phí khác (₫)" :disabled="lockedOrder || orderEditable.CheckPayment == 1"></h-currency-input>
                                                </v-flex>
                                                <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                    <v-text-field v-model="orderEditable.FeeOtherNote" label="Ghi chú" class="input-group--focused" :disabled="lockedOrder || orderEditable.CheckPayment == 1"></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout class="blue--text" row wrap v-if="orderEditable.IsFragileGoods">
                                        <v-flex lg3 sm3 pt-0>
                                            <v-card-text>Phí đóng gỗ</v-card-text>
                                        </v-flex>
                                        <v-flex lg9 sm9 pt-0>
                                            <v-layout row wrap>
                                                <v-flex lg4 sm4 pa-0 pl-2 pr-2>
                                                    <h-currency-input v-model="orderEditable.FragileFee" label="¥" :decimal="1" :disabled="!(adminRole || paymentRole || (purchaseRole && csRole)) || lockedOrder || orderEditable.CheckPayment == 1"></h-currency-input>
                                                </v-flex>
                                                <v-flex lg2 sm2 pa-0 pl-2 pr-2>
                                                    <v-checkbox class="pt-6" v-model="orderEditable.FixFragileFee" label="Fix đơn giá" v-if="adminRole || paymentRole" :disabled="lockedOrder || orderEditable.CheckPayment == 1"></v-checkbox>
                                                </v-flex>
                                                <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                    <h-currency-input v-model="orderEditable.FragileFeeVND" :decimal="0" label="₫" disabled ></h-currency-input>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout class="blue--text" row wrap v-if="orderEditable.IsFoam">
                                        <v-flex lg3 sm3 pt-0>
                                            <v-card-text>Phí bọt khí</v-card-text>
                                        </v-flex>
                                        <v-flex lg9 sm9 pt-0>
                                            <v-layout row wrap>
                                                <v-flex lg4 sm4 pa-0 pl-2 pr-2>
                                                    <h-currency-input v-model="orderEditable.FoamFee" label="¥" :decimal="1" :disabled="!(adminRole || paymentRole || (purchaseRole && csRole)) || lockedOrder || orderEditable.CheckPayment == 1"></h-currency-input>
                                                </v-flex>
                                                <v-flex lg2 sm2 pa-0 pl-2 pr-2>
                                                    <v-checkbox class="pt-6" v-model="orderEditable.FixFoamFee" label="Fix đơn giá" v-if="adminRole || paymentRole" :disabled="lockedOrder || orderEditable.CheckPayment == 1"></v-checkbox>
                                                </v-flex>
                                                <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                    <h-currency-input v-model="orderEditable.FoamFeeVND" :decimal="0" label="₫" disabled ></h-currency-input>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout class="blue--text" row wrap v-if="orderEditable.IsCheck">
                                        <v-flex lg3 sm3 pt-0>
                                            <v-card-text>Phí kiểm hàng</v-card-text>
                                        </v-flex>
                                        <v-flex lg9 sm9 pt-0>
                                            <v-layout row wrap>
                                                <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                    <!-- <h-currency-input v-model="orderEditable.CheckFee" label="¥" :decimal="1" :disabled="!(order.Status == statusEnum.dang_den_kho_gui || paymentRole || adminRole)"></h-currency-input> -->
                                                    <h-currency-input v-model="orderEditable.CheckFeeVND" :decimal="0" label="₫" disabled></h-currency-input>
                                                </v-flex>
                                                <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                    
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout class="blue--text" row wrap v-if="orderEditable.GuaranteeType > 0">
                                        <v-flex lg3 sm3 pt-0>
                                            <v-card-text>Phí bảo hiểm</v-card-text>
                                        </v-flex>
                                        <v-flex lg9 sm9 pt-0>
                                            <v-layout row wrap>
                                                <v-flex lg4 sm4 pa-0 pl-2 pr-2>
                                                    <h-currency-input v-model="orderEditable.GuaranteeAmountVND" :decimal="0" label="₫" :disabled="!(adminRole || paymentRole) || lockedOrder || orderEditable.CheckPayment == 1"></h-currency-input>
                                                </v-flex>
                                                <v-flex lg2 sm2 pa-0 pl-2 pr-2>
                                                    <v-checkbox class="pt-6" v-model="orderEditable.FixGuaranteeFee" label="Fix đơn giá" v-if="adminRole || paymentRole" :disabled="lockedOrder || orderEditable.CheckPayment == 1"></v-checkbox>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout class="blue--text font-weight-bold" row wrap>
                                        <v-flex lg3 sm3 pt-0 pb-0>
                                            <v-card-text>Voucher</v-card-text>
                                        </v-flex>
                                        <v-flex lg9 sm9 pt-0 pb-0>
                                            <v-layout row wrap>
                                                <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                    <h-currency-input v-model="order.VoucherAmount" :decimal="0" label="Số tiền giảm" readonly></h-currency-input>
                                                </v-flex>
                                                <v-flex lg6 sm6 pa-0 pl-2 pr-2 pt-2>
                                                    <v-btn color="blue darken-1" outlined :disabled="!((order.PriceType == 2 && order.Status == 11) || order.Status == 7 || paymentRole || adminRole) || orderEditable.CheckPayment == 1" @click="voucherPopup = true">Chọn voucher</v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                        <v-flex lg3 sm3 pt-0 pb-0>
                                            <v-card-text>Chiết khấu phí dịch vụ</v-card-text>
                                        </v-flex>
                                        <v-flex lg9 sm9 pt-0 pb-0>
                                            <v-layout row wrap>
                                                <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                    <h-currency-input v-model="order.TotalDiscount" :decimal="0" label="Chiết khấu phí dịch vụ" disabled></h-currency-input>
                                                </v-flex>
                                                <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                        <v-flex lg3 sm3 pt-0 pb-0>
                                            <v-card-text>Giảm trừ đơn hàng</v-card-text>
                                        </v-flex>
                                        <v-flex lg9 sm9 pt-0 pb-0>
                                            <v-layout row wrap>
                                                <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                    <h-currency-input v-model="orderEditable.DiscountVND" :decimal="0" label="Giảm trừ đơn hàng" :disabled="!(adminRole || paymentRole) || orderEditable.CheckPayment == 1"></h-currency-input>
                                                </v-flex>
                                                <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap class="font-weight-bold">
                                        <v-flex lg3 sm3 pt-0>
                                            <v-card-text>Đã thanh toán</v-card-text>
                                        </v-flex>
                                        <v-flex lg9 sm9 pt-0>
                                            <v-layout row wrap>
                                                <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                    <h-currency-input v-model="order.Payment" :decimal="0" label="₫" disabled></h-currency-input>
                                                </v-flex>
                                                <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                    
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap class="red--text font-weight-bold">
                                        <v-flex lg3 sm3 pt-0>
                                            <v-card-text>Cần thanh toán</v-card-text>
                                        </v-flex>
                                        <v-flex lg9 sm9 pt-0>
                                            <v-layout row wrap>
                                                <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                    <h-currency-input showClass="red--text" v-model="remainAmount" :decimal="0" label="₫" disabled></h-currency-input>
                                                </v-flex>
                                                <v-flex lg6 sm6 pa-0 pl-2 pr-2>
                                                    
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </div>
                    </v-widget>
                </v-flex>
                <!-- Lich su thanh toan -->
                <v-flex sm12 md12 lg12>
                    <v-widget title="Lịch sử thanh toán">
                        <div slot="widget-content">
                            <v-data-table :headers="paymentHistoryHeader" :items="order.PaymentHistory" :mobile-breakpoint="100" disable-pagination hide-default-footer>
                                <template  v-slot:item="{ item }">
                                    <tr>
                                        <td>{{ item.CreatedDate | display_date }}</td>
                                        <td>
                                            <v-chip label small :color="item.Status | payment_type_color" text-color="white">{{ item.Status | payment_type}}</v-chip>
                                        </td>
                                        <td>{{ item.Type | payment_method }}</td>
                                        <td class="text-end">{{ item.Amount | currency }}</td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </div>
                    </v-widget>
                </v-flex>
                <!-- Lich su thay doi -->
                <v-flex sm12 md12 lg12>
                    <v-widget title="Lịch sử thay đổi">
                        <div slot="widget-content">
                            <v-data-table :headers="changedHistoryHeader" :items="changedHistories" :mobile-breakpoint="100" disable-pagination hide-default-footer>
                                <template  v-slot:item="{ item }">
                                    <tr>
                                        <td>{{ item.CreatedDate | display_date }}</td>
                                        <td>{{ item.Username}}</td>
                                        <td>{{ item.HistoryContent}}</td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </div>
                    </v-widget>
                </v-flex>
                <!-- Lich su khieu nai -->
                <v-flex sm12 md12 lg12 v-if="order.OrderComplains && order.OrderComplains.length > 0">
                    <v-widget title="Lịch sử khiếu nại">
                        <div slot="widget-content">
                            <v-data-table :headers="orderComplainHeader" :items="order.OrderComplains" :mobile-breakpoint="100" :footer-props="{ 'items-per-page-options': [10, 20, 30, 40, 50] }" :items-per-page="10">
                                <template  v-slot:item="{ item }">
                                    <tr>
                                        <td>{{ item.ID}}</td>
                                        <td class="text-end">{{ item.Amount | currency}}</td>
                                        <td>{{ item.ComplainText}}</td>
                                        <td>{{ item.CreatedDate | display_date }}</td>
                                        <td>
                                            <v-chip label small :color="item.Status | complain_type_color" text-color="white">{{ item.Status | complain_type}}</v-chip>
                                        </td>
                                        <td class="text-center">
                                            <v-btn v-if="complainRole" small color="primary" @click="gotoComplainDetail(item.ID)">Chi tiết</v-btn>
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </div>
                    </v-widget>
                </v-flex>
            </v-layout>
            <v-dialog v-model="dialogCancelOrder" max-width="300px">
                <v-card>
                    <v-card-title>
                        <span class="title">Xác nhận hủy đơn hàng</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container grid-list-md pa-0>
                            <v-layout row wrap>
                            <v-flex lg12>
                                <h-currency-input label="Tiền hoàn khách" v-model="backAmountVND" :decimal="0"></h-currency-input>
                            </v-flex>
                            <v-flex lg12>
                                <v-select :items="cancel_reason_list" v-model="cancelReason" item-text="name" item-value="value"></v-select>
                            </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1 white--text" @click="dialogCancelOrder = false">Đóng</v-btn>
                        <v-btn color="red darken-1 white--text" @click="CancelOrder">OK</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogOtherFee" persistent max-width="800px">
                <v-card>
                    <v-card-title>
                        <span class="title">Danh sách phí khác</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container grid-list-md pa-0>
                            <v-layout row wrap v-if="((order.Status != statusEnum.hoan_thanh && order.Status != statusEnum.da_thanh_toan) || (!lockedOrder && paymentRole) || adminRole)">
                                <v-flex lg6>
                                    <v-select :items="other_fee_config" v-model="selectedOtherFee" item-text="name" item-value="value"></v-select>
                                </v-flex>
                                <v-flex lg6 pt-6>
                                    <v-btn class="mx-2" small @click="addOtherFeeItem"><v-icon>fa-plus</v-icon></v-btn>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex lg12 v-if="otherFees">
                                    <v-data-table :headers="otherFeeHeader" :items="otherFees" hide-default-footer :mobile-breakpoint="100" :items-per-page="20">
                                        <template  v-slot:item="{ item }">
                                            <tr>
                                                <td>{{ item.FeeName }}</td>
                                                <td class="text-end" v-if="((order.Status != statusEnum.hoan_thanh && order.Status != statusEnum.da_thanh_toan) || (!lockedOrder && paymentRole) || adminRole)">
                                                    <v-edit-dialog :return-value.sync="item.Amount" large lazy persistent @save="updateOtherFeeItem({'ID': item.ID, 'Amount': item.Amount})">
                                                        <div>{{ item.Amount | currency}}</div>
                                                        <template v-slot:input>
                                                            <h-currency-input label="Tiền phí" v-model="item.Amount" :decimal="0" :autoEmit="true"></h-currency-input>
                                                        </template>
                                                    </v-edit-dialog>
                                                </td>
                                                <td v-else>{{ item.Amount | currency}}</td>
                                                <td v-if="((order.Status != statusEnum.hoan_thanh && order.Status != statusEnum.da_thanh_toan) || (!lockedOrder && paymentRole) || adminRole)">
                                                    <v-edit-dialog :return-value.sync="item.Note" large lazy persistent @save="updateOtherFeeItem({'ID': item.ID, 'Note': item.Note})">
                                                        <div>{{ item.Note }}</div>
                                                        <template v-slot:input>
                                                            <v-text-field label="Ghi chú" v-model="item.Note"></v-text-field>
                                                        </template>
                                                    </v-edit-dialog>
                                                </td>
                                                <td class="text-center"><v-icon medium @click="deleteOtherFeeItem(item.ID)" v-if="((order.Status != statusEnum.hoan_thanh && order.Status != statusEnum.da_thanh_toan) || (!lockedOrder && paymentRole) || adminRole)">delete</v-icon></td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1 white--text" @click="dialogOtherFee = false">Đóng</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <voucher-popup :modalDialog="voucherPopup" :order_id="order.ID" :order_type="2" :uid="order.UID" :user_name="order.Username" :order_code="order.OrderCode" @closePopup="voucherPopup = false"></voucher-popup>
        </v-container>
    </div>
    </template>
    
    <script>
    import VWidget from "@/components/VWidget";
    import MessageBox from "@/components/chat/MessageBox";
    import OrderTransaction from "@/components/widgets/OrderTransaction";
    import { sendErrorNotice } from "@/commons/utils";
    import OrderFlag from "@/components/widgets/OrderFlag";
    import voucher from "@/components/popups/voucher";
    import { mapState } from "vuex";
    import configs from "@/configs";
    import _ from "lodash";
    import {
        payment_type,
        payment_type_color,
        complain_type,
        complain_type_color
    } from "@/commons/hpod";
    
    export default {
        filters: {
            payment_type,
            payment_type_color,
            complain_type,
            complain_type_color,
            payment_method: function (value) {
                return value == 1 ? "Trực tiếp" : "Ví điện tử";
            },
    
        },
        components: {
            VWidget,
            MessageBox,
            'order-flag-menu': OrderFlag,
            'order-transaction': OrderTransaction,
            'voucher-popup': voucher
        },
        data() {
            return {
                extraOptions: '',
                voucherPopup: false,
                selectedOtherFee: 0,
                dialogOtherFee: false,
                backAmountVND: 0,
                dialogCancelOrder: false,
                isCheckPackageA: false,
                isCheckPackageB: false,
                showCustomerDetail: false,
                tempOrder: {},
                dialogProduct: false,
                message: "",
                timeout: 100000,
                events: [],
                input: null,
                nonce: 0,
                search: "",
                statusEnum: configs.ORDER_DEPOSIT_STATUS_ENUM,
                feeshiptypes: configs.ORDER_FEESHIP_TYPES,
                editedProIndex: -1,
                cancelReason: 2,
                editedPro: {
                    quantity: 0,
                    price: 0
                },
                orderEditable: {
                    OrderID: 0,
                    FeeShipCN: 0,
                    ChinaStoreID: 0,
                    ReceivePlaceID: 0,
                    CurentCNYVN: 0,
                    WeightPrice: 0,
                    FeeOther: 0,
                    FeeOtherNote: '',
                    IsFragileGoods: false,
                    IsCheck: false,
                    CheckFeeType: 0,
                    FragileFee: 0,
                    FragileFeeVND: 0,
                    CheckFee: 0,
                    CheckFeeVND: 0,
                    DiscountVND: 0,
                    GuaranteeType: 0,
                    GuaranteeAmountVND: 0,
                    FeeShipType: 0,
                    IsUpdateFeeShip: 0,
                    Status: 0,
                    ListedWeightPrice: 0,
                    FixListedWeightPrice: 0,
                    ListedWeightPriceSnd: 0,
                    FixListedWeightPriceSnd: 0,
                    FixFragileFee: 0,
                    FixGuaranteeFee: 0,
                    WeightPriceSnd: 0,
                    IsUpdateFeeShipSnd: 0,
                    ReceiveAddress: 0,
                    ProductType: 0,
                    OtherFeeObj: null,
                    FeeShipVN: 0,
                    RealFeeShipVN: 0,
                    RealFeeShipCN: 0,
                    CheckPayment: 0,
                    IsFoam: 0,
                    FixFoamFee: 0,
                    FoamFee: 0,
                    FoamFeeVND: 0,
                    SafeLevelID: 0,
                    FeeWeightCommission: 0,
                    FixFeeWeightCommission: 0
                },
                totalRealAmount: 0,
                otherFeeHeader: [
                    {
                        text: "Loại phí",
                        sortable: false
                    },
                    {
                        text: "Số tiền",
                        sortable: false,
                        align: "end"
                    },
                    {
                        text: "Ghi chú",
                        sortable: false,
                    },
                    {
                        text: "",
                        sortable: false,
                        align: "center"
                    }
                ],
                paymentHistoryHeader: [{
                        text: "Ngày thanh toán",
                        value: "CreatedDate",
                        sortable: false
                    },
                    {
                        text: "Loại thanh toán",
                        value: "Status",
                        sortable: false
                    },
                    {
                        text: "Hình thức thanh toán",
                        value: "Type",
                        sortable: false
                    },
                    {
                        text: "Số tiền",
                        value: "Amount",
                        sortable: false,
                        align: "end"
                    }
                ],
                changedHistoryHeader: [{
                        text: "Ngày thay đổi",
                        value: "CreatedDate",
                        sortable: false
                    },
                    {
                        text: "Người thay đổi",
                        value: "Username",
                        sortable: false
                    },
                    {
                        text: "Nội dung",
                        value: "HistoryContent",
                        sortable: false
                    }
                ],
                orderComplainHeader: [{
                        text: "ID",
                        value: "ID",
                        sortable: false
                    },
                    {
                        text: "Số tiền",
                        value: "Amount",
                        sortable: false,
                        align: "end"
                    },
                    {
                        text: "Nội dung",
                        value: "ComplainText",
                        sortable: false
                    },
                    {
                        text: "Ngày tạo",
                        value: "CreatedDate",
                        sortable: false
                    },
                    {
                        text: "Trạng thái",
                        value: "Status",
                        sortable: false
                    },
                    {
                        text: "Thao tác",
                        align: "center",
                        value: "",
                        sortable: false
                    }
                ],
            };
        },
        computed: {
            orderId() {
                return Number(this.$route.params.Pid);
            },
            orderStatus() {
                return configs.ORDER_DEPOSIT_STATUS;
            },
            cancel_reason_list() {
                return _.filter(configs.CANCEL_REASON, {'disabled': false});
            },
            orderPaymentReady() {
                return this.order.Status == configs.ORDER_DEPOSIT_STATUS_ENUM.da_nhap_kho_nhan;
            },
            canReorder() {
                return this.order.Status == configs.ORDER_DEPOSIT_STATUS_ENUM.huy_don_hang;
            },
            lockedOrder() {
                return (this.order.Status == configs.ORDER_DEPOSIT_STATUS_ENUM.hoan_thanh || this.order.Status == configs.ORDER_DEPOSIT_STATUS_ENUM.da_thanh_toan) && !(this.paymentRole || this.adminRole);
            },
            orderReadonly() {
                return this.order.Status == configs.ORDER_DEPOSIT_STATUS_ENUM.huy_don_hang || this.order.Status == configs.ORDER_DEPOSIT_STATUS_ENUM.hoan_thanh;
            },
            paymentRole() {
                return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
            },
            adminRole() {
                return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
            },
            saleRole() {
                return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService && (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase;
            },
            purchaseRole() {
                return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase;
            },
            csRole() {
                return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService;
            },
            storeVNRole() {
                return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreVN) == configs.ROLE_TYPE.StoreVN;
            },
            customerView() {
                return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Manager) == configs.ROLE_TYPE.Manager) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreVN) == configs.ROLE_TYPE.StoreVN);
            },
            complainRole() {
                return ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin) || ((this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase);
            },
            orderRole() {
                return this.$store.state.authentication.role.Orders;
            },
            orderEditRole() {
                return this.$store.state.authentication.role.OrderEditable;
            },
            ...mapState({
                configuration: state => state.configuration.selected,
                order: state => state.deposit.selected,
                customer: state => state.customer.selected,
                vipLevels: state => state.customerLevel.all.data,
                changedHistories: state => state.changedHistories.all.data,
                warehouses: state => state.commons.stores,
                chinaStores: state => state.commons.chinaStores,
                all_guarantees: state => state.feeGuarantee.all.data,
                allFlags: state => state.orderFlag.all.data,
                transCodes: state => state.orderTransaction.all.data,
                vouchers: state => state.customer.vouchers,
                otherFees: state => state.orderFee.all.data,
                safeLevels: state => state.safeLevel.safe_level_by_store,
            }),
            ...mapState("deposit", {
                loading: "loading",
            }),
            guarantees() {
                let tmp = [{PackageName: 'Không sử dụng', ID: 0}];
                if(this.all_guarantees) {
                    tmp = tmp.concat(_.filter(this.all_guarantees, (o) => {return (o.IsExport && this.order.PriceType == 2) || (!o.IsExport && this.order.PriceType != 2)}));
                }
                return tmp;
            },
            remainAmount() {
                return this.order.TotalPriceVND - this.order.Payment;
            },
            totalWeight() {
                return _.sumBy(this.transCodes, (o) => {return (o.Weight > o.WeightByVolume ?  o.Weight : o.WeightByVolume)*10})/10;
            },
            //totalVolume() {
            //    return Math.round(_.sumBy(this.transCodes, (o) => {return (o.Length*o.Width*o.Height/1000000)}) * 100)/100;
            //},
            totalVolume() {
                if(!this.transCodes) {
                    return 0;
                }
                // Nhóm 1: Có Packages
                const withPackages = this.transCodes.filter(o => o.Packages && o.Packages.length > 0);
                // Nhóm 2: Không có Packages
                const withoutPackages = this.transCodes.filter(o => !o.Packages || o.Packages.length === 0);

                const totalWithPackages = _.sumBy(withPackages, o => o.Volume || 0);
                const totalWithoutPackages = Math.round(_.sumBy(withoutPackages, o => (o.Length * o.Width * o.Height / 1000000)) * 100) / 100;

                return totalWithPackages + totalWithoutPackages;
            },
            //totalVolume() {
            //    return _.sumBy(this.transCodes, (o) => {return o.Volume});
            //},
            totalWeightByBigpackage() {
                if(!this.totalWeight && !this.totalVolume) {
                    const groupByBigpackage = _.map(_.groupBy(this.transCodes, 'BigPackageID'), (items, BigPackageID) => ({
                        'BigPackageID': BigPackageID,
                        'TotalWeight': items[0].BigpackageWeight  // lấy weight của phần tử đầu tiên
                    }));
                    return _.sumBy(groupByBigpackage, (o) => {return o.TotalWeight*10})/10;
                }
                return 0;
            },
            totalVolumeByBigpackage() {
                if(!this.totalWeight && !this.totalVolume) {
                    const groupByBigpackage = _.map(_.groupBy(this.transCodes, 'BigPackageID'), (items, BigPackageID) => ({
                        'BigPackageID': BigPackageID,
                        'TotalVolume': items[0].BigpackageVolume  // lấy Volume của phần tử đầu tiên
                    }));
                    return _.sumBy(groupByBigpackage, (o) => {return o.TotalVolume*100})/100;
                }
                return 0;
            },
            existExported() {
                let tmp = _.filter(this.transCodes, (o) => {return o.Status == configs.PACKAGE_STATUS_ENUM.KH_DA_NHAN});
                return tmp.length > 0;
            },
            product_types() {
                return this.configuration && this.configuration.ProductTypes ? JSON.parse(this.configuration.ProductTypes) : [];
            },
            warehouse_list() {
                return _.filter(this.warehouses, function (o) {
                    return o.StoreType == 1;
                })
            },
            chinaStore_list() {
                return _.filter(this.chinaStores, function (o) {
                    return o.StoreType == 1;
                })
            },
            r_warehouse_list() {
                return _.filter(this.warehouses, function (o) {
                    return o.StoreType == 2;
                })
            },
            r_chinaStore_list() {
                return _.filter(this.chinaStores, function (o) {
                    return o.StoreType == 2;
                })
            },
            other_fee_config() {
                let tmp = this.configuration && this.configuration.OtherFeeObj ? JSON.parse(this.configuration.OtherFeeObj) : [];
                return _.filter(tmp, {'ignore': 0});
            },
            feeWeightCommissionRate() {
                let tmp = this.configuration && this.configuration.FeeWeightCommissionRates ? JSON.parse(this.configuration.FeeWeightCommissionRates) : [];
                return _.find(tmp, {'warning': 1});
            },
            warningFeeWeight() {
                let rate = !this.order.WeightPriceSnd ? (this.order.WeightPrice-this.order.ListedWeightPrice)/this.order.WeightPrice*100 : (this.order.WeightPriceSnd-this.order.ListedWeightPriceSnd)/this.order.WeightPriceSnd*100;
                if(this.feeWeightCommissionRate && this.feeWeightCommissionRate.max <= rate && !this.order.CheckPayment) {
                    return true;
                }
                return false;
            },
            diffChinaStoreID() {
                let tmp = _.filter(this.transCodes, (o) => {return o.SelfChinaStoreID && o.SelfChinaStoreID != this.order.ChinaStoreID});
                return tmp.length > 0;
            },
            diffUID() {
                let tmp = _.filter(this.transCodes, (o) => {return o.StoreUID && o.StoreUID != this.order.UID});
                return tmp.length > 0;
            },
            missingPackage() {
                return _.some(this.transCodes, (o) => {return o.MissingPackage == 1 || (o.NumberOfPack > o.RealNumberOfPack && o.Packages && o.Packages.length > 0)});
            }
        },
        watch: {
            orderId() {
                this.refreshData();
            },
            order() {
                this.extraOptions = this.order.SafeLevelID ? 'safe-level' : 'optional';
                this.orderEditable = {
                    OrderID: this.order.ID,
                    FeeShipCN: this.order.FeeShipCN,
                    ChinaStoreID: this.order.ChinaStoreID,
                    ReceivePlaceID: this.order.ReceivePlaceID,
                    CurentCNYVN: this.order.CurentCNYVN,
                    WeightPrice: this.order.WeightPrice,
                    FeeOther: this.order.FeeOther,
                    FeeOtherNote: this.order.FeeOtherNote,
                    IsFragileGoods: this.order.IsFragileGoods,
                    IsCheck: this.order.IsCheck,
                    CheckFeeType: this.order.CheckFeeType,
                    FragileFee: this.order.FragileFee,
                    FragileFeeVND: this.order.FragileFeeVND,
                    CheckFee: this.order.CheckFee,
                    CheckFeeVND: this.order.CheckFeeVND,
                    DiscountVND: this.order.DiscountVND,
                    GuaranteeType: this.order.GuaranteeType,
                    GuaranteeAmountVND: this.order.GuaranteeAmountVND,
                    FeeShipType: this.order.FeeShipType,
                    IsUpdateFeeShip: this.order.IsUpdateFeeShip,
                    Status: this.order.Status,
                    ListedWeightPrice: this.order.ListedWeightPrice,
                    FixListedWeightPrice: this.order.FixListedWeightPrice,
                    ListedWeightPriceSnd: this.order.ListedWeightPriceSnd,
                    FixListedWeightPriceSnd: this.order.FixListedWeightPriceSnd,
                    FixFragileFee: this.order.FixFragileFee,
                    FixGuaranteeFee: this.order.FixGuaranteeFee,
                    WeightPriceSnd: this.order.WeightPriceSnd,
                    IsUpdateFeeShipSnd: this.order.IsUpdateFeeShipSnd,
                    ReceiveAddress: this.order.ReceiveAddress,
                    ProductType: this.order.ProductType,
                    OtherFeeObj: this.order.OtherFeeObj,
                    FeeShipVN: this.order.FeeShipVN,
                    RealFeeShipVN: this.order.RealFeeShipVN,
                    RealFeeShipCN: this.order.RealFeeShipCN,
                    CheckPayment: this.order.CheckPayment,
                    IsFoam: this.order.IsFoam,
                    FixFoamFee: this.order.FixFoamFee,
                    FoamFee: this.order.FoamFee,
                    FoamFeeVND: this.order.FoamFeeVND,
                    SafeLevelID: this.order.SafeLevelID,
                    FeeWeightCommission: this.order.FeeWeightCommission,
                    FixFeeWeightCommission: this.order.FixFeeWeightCommission,
                };
                this.tempOrder = {...this.orderEditable};
                this.isCheckPackageA = this.order.IsCheck && this.order.CheckFeeType == 1;
                this.isCheckPackageB = this.order.IsCheck && this.order.CheckFeeType == 2;
                if(this.order.UID) {
                    this.$store.dispatch("customer/getCustomerDetail", this.order.UID);
                    this.$store.dispatch("customer/getCustomerVoucher", {id: this.order.UID, order_id: this.order.ID, order_type: 2});
                }
                if(this.order.ChinaStoreID) {
                    this.$store.dispatch("safeLevel/get_safe_level_by_store", this.order.ChinaStoreID);
                }
            },
            orderEditable: {
                handler: function (newVal, oldVal) {
                    this.updateOrderDetail(newVal, oldVal);
                },
                deep: true,
                immediate: true
            },
            isCheckPackageA() {
                if(this.isCheckPackageA) {
                    this.isCheckPackageB = false;
                    this.orderEditable.IsCheck = 1;
                    this.orderEditable.CheckFeeType = 1;
                }
                if(!this.isCheckPackageA && !this.isCheckPackageB) {
                    this.orderEditable.IsCheck = 0;
                    this.orderEditable.CheckFeeType = 0;
                }
            },
            isCheckPackageB() {
                if(this.isCheckPackageB) {
                    this.isCheckPackageA = false;
                    this.orderEditable.IsCheck = 1;
                    this.orderEditable.CheckFeeType = 2;
                }
                if(!this.isCheckPackageA && !this.isCheckPackageB) {
                    this.orderEditable.IsCheck = 0;
                    this.orderEditable.CheckFeeType = 0;
                }
            }
        },
        methods: {
            closePanel() {
                this.$router.push({
                    name: "OrderList"
                });
            },
            refreshData() {
                this.orderEditable.OrderID = 0;
                this.$store.dispatch("deposit/getDetail", this.orderId);
                this.$store.dispatch("feeGuarantee/getList");
                this.$store.dispatch("orderFee/getList", {'OrderID': this.orderId, 'OrderType': configs.ORDER_TYPE.deposit});
                this.$store.dispatch("customerLevel/getCustomerLevelList");
                
                var param = {
                    'orderId': this.orderId,
                    'orderType': 2
                };
                this.$store.dispatch("changedHistories/getList", param);
            },
            updateOrderDetail: _.debounce(function (newVal, oldVal) {
                if (oldVal && oldVal.OrderID !== 0) {
                    if(!_.isEqual(newVal, this.tempOrder)){
                        this.tempOrder = {...newVal};
                        let updateObject = {OrderID: newVal.OrderID};
                        for (const prop in newVal) {
                            if(newVal[prop] != this.order[prop]) {
                                updateObject[prop] = newVal[prop];
                                if(prop == 'SafeLevelID') {
                                    updateObject[prop] = updateObject[prop] != null ? updateObject[prop] : 0; 
                                }
                            }
                        }
                        // if(newVal.WeightPrice < newVal.ListedWeightPrice || (newVal.PriceType == 2 && newVal.WeightPriceSnd < newVal.ListedWeightPriceSnd)) {
                        //     sendErrorNotice("Giá bán không được nhỏ hơn giá niêm yết!");
                        //     return;
                        // }
                        this.tempOrder = _.cloneDeep(newVal);
                        this.$store.dispatch("deposit/setDetail", {data: updateObject});
                    }
                }
            }, 1000),
            getVipValue(id) {
                const item = _.find(this.vipLevels, {'ID': id});
                return item ? item.VIPName : '';
            },
            CancelOrder() {
                if(this.order.Status != configs.ORDER_DEPOSIT_STATUS_ENUM.hoan_thanh) {
                    this.$store.dispatch("deposit/setDetail", {data: {OrderID: this.order.ID, Status: configs.ORDER_DEPOSIT_STATUS_ENUM.huy_don_hang, BackAmountVND: this.backAmountVND, CancelReason: this.cancelReason}});
                    this.dialogCancelOrder = false;
                }
                else {
                    sendErrorNotice("Không thể hủy đơn hàng!");
                }
            },
            MarkDoneOrder() {
                if(this.order.Status == configs.ORDER_DEPOSIT_STATUS_ENUM.da_nhap_kho_nhan) {
                    this.orderEditable.Status = configs.ORDER_DEPOSIT_STATUS_ENUM.cho_thanh_toan;
                }
                else {
                    sendErrorNotice("Không đổi trạng thái đơn hàng!");
                }
            },
            ReOrder() {
                if(this.order.Status == configs.ORDER_DEPOSIT_STATUS_ENUM.huy_don_hang) {
                    this.orderEditable.Status = configs.ORDER_DEPOSIT_STATUS_ENUM.dang_den_kho_gui;
                }
                else {
                    sendErrorNotice("Không đổi trạng thái đơn hàng!");
                }
            },
            openCustomerDetail: function() {
                this.showCustomerDetail = !this.showCustomerDetail;
            },
            gotoCustomerDetail: function(id) {
                let routeData = this.$router.resolve({
                    name: "CustomerDetail",
                    params: {
                    Pid: id,
                    title: `Khách hàng (#${id})`
                    }
                });
                window.open(routeData.href, "_blank");
            },
            gotoComplainDetail(id) {
                let routeData = this.$router.resolve({
                    path: `/khieu-nai/don-hang/${id}`,
                    params: {
                    Pid: id,
                    title: `Chi tiết khiếu nại (#${id})`
                    }
                });
                window.open(routeData.href, "_blank");
            },
            openOtherFeePopup() {
                this.dialogOtherFee = true;
            },
            updateOtherFeeItem(item) {
                this.$store.dispatch("orderFee/setDetail", {
                    data: item,
                    id: item.ID
                });
            },
            deleteOtherFeeItem(id) {
                this.$store.dispatch("orderFee/removeDetail", id);
            },
            addOtherFeeItem() {
                if(!this.selectedOtherFee) {
                    sendErrorNotice("Hãy chọn loại phí cho đơn hàng.");
                    return;
                }
                if(_.find(this.otherFees, {'FeeType': this.selectedOtherFee})) {
                    sendErrorNotice("Loại phí đã tồn tại trên đơn hàng.");
                    return;
                }
                const tmp = _.find(this.other_fee_config, {'value': this.selectedOtherFee});
                this.$store.dispatch("orderFee/setDetail", {
                    data: {
                        OrderID: this.order.ID,
                        OrderType: configs.ORDER_TYPE.deposit,
                        FeeType: tmp.value,
                        FeeName: tmp.name,
                        Amount: 0
                    },
                    id: 0
                });
            },
            duplicateOrder() {
                this.$store.dispatch("deposit/duplicateDetail", this.order.ID).then((p) => {
                    let routeData = this.$router.resolve({
                        name: "DepositDetail",
                        params: {
                            Pid: p.data.ID,
                            title: `Chi tiết đơn hàng (#${p.data.ID})`
                        }
                    });
                    window.open(routeData.href, "_blank");
                }).catch((error) => {
                    sendErrorNotice("Không thể nhân bản đơn hàng: " + error.message);
                });
            }
        },
        mounted() {
            this.$store.dispatch("commons/getAllStores");
            this.$store.dispatch("commons/getAllChinaStores");
            this.$store.dispatch("configuration/getDetail", 1);
            this.$store.dispatch("safeLevel/getList");
            this.$root.$on("REQUEST_REFRESH_DATA", this.refreshData);
            this.$root.$on("CONFIRMED_ACTION", ({action, id}) => {
                if(action == 'editNumberOfPack') {
                    this.duplicateOrder();
                }
            });
            this.refreshData();
        },
        beforeDestroy() {
            this.$root.$off("REQUEST_REFRESH_DATA");
            this.$root.$off("CONFIRMED_ACTION");
        }
    };
    </script>
    
    <style scoped>
    .product-title {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    
    .v-list--two-line .v-list__tile {
        height: auto !important;
        padding: 5px 0 5px 0;
    }
    
    .theme--light.red--text.v-input--is-disabled input {
        color: #f44336 !important;
        caret-color: #f44336 !important;
    }
    
    .fee-cn-footer .v-text-field .v-label--active {
        right: 0px !important;
        left: auto !important;
    }
    
    .fee-cn-footer .v-text-field__slot input {
        text-align: right !important;
        font-size: 0.9em !important;
    }
    
    .image-product {
        width: 64px;
    }
    
    .text-red .v-select__selection,
    .text-red .v-icon.v-icon {
        color: #a77800!important;
    }
    .warning-amount {
        background-color: #ffc5c5;
    }
    </style>
    